import React from 'react';
import { Row, Col } from 'reactstrap';
import { Link } from 'react-router-dom';
import Moment from 'moment';

const PromotionRow = ({ promotion }) => {
  if (!promotion) return null;

  return (
    <div>
      <Row className='promotion-row'>
        <Col md='1' className='white-border'>
          {promotion.externalId}
        </Col>
        <Col md='7' className='white-border'>
          <Link
            to={`/campaign/${promotion.campaignId}/promotions/${promotion.id}`}
            className='row-link-active'
          >
            {promotion.name} - {promotion.description}
          </Link>
        </Col>
        <Col md='1' className='white-border'>
          {Moment(promotion.startDate).format('DD MMM YYYY')}
        </Col>
        <Col md='1' className='white-border'>
          {Moment(promotion.endDate).format('DD MMM YYYY')}
        </Col>
        <Col md='1' className='white-border'>
          {promotion.status}
        </Col>
        <Col md='1' className='white-border'>
          <Link
            to={`/campaign/${promotion.campaignId}/promotions/${promotion.id}/offers/add-offer`}
            className={`btn btn-primary${promotion.isReadOnly ? ' disabled' : ''}`}
          >
            Add Offer
          </Link>
        </Col>
      </Row>
    </div>
  );
};

export default PromotionRow;
